
import { mapState } from 'vuex'

export default{
    computed:{
        ...mapState(['user']),
    },
	methods:{

		verificaSePodeAcessar(){
            let retorno = ""

            
            if(this.$store.state.iniciado.iniciado == this.$store.state.user.iniciado){
                retorno = false
            }else if(this.$store.state.iniciado.mestre == '0' && this.$store.state.user.outros.perfil != '4'){
                retorno = false
            }else if(this.$store.state.iniciado.mestre != this.$store.state.user.iniciado && this.$store.state.iniciado.mestre != '0'){
                retorno = false
            }else{
                retorno = true
            }

            return retorno
        },

        mostrarDescricaoMedicao(nome){
            let descricao = ""
            switch(nome){
                case "P":
                    descricao = 'Parado';
                    break;
                case "A":
                    descricao = 'Anti-Horário';
                    break;
                case "H":
                    descricao = 'Horário';
                    break;
            }

            return descricao
        },

        mostrarData(dt){
            let data = this.converterData(dt)
            return ("0" + data.getDate()).slice(-2) + '/' + ("0" + (data.getMonth() + 1)).slice(-2) + '/' + data.getFullYear()
        },

        converterData(dt){
            let data = new Date(dt)
            let difHorario = data.getTimezoneOffset() / 60
            data = new Date(data.setHours(data.getHours() + difHorario))
            
            return data
        },

        converterHora(hr){
            let data = new Date().toISOString().substr(0,10)
            const [year, month, day] = data.split('-')
            data = new Date(year, month-1, day, hr.substr(0,2), hr.substr(3,2))
    
            return data
       },

        formataDateBr (dt) {
            if (!dt){
                return null
            } 
            const [year, month, day] = dt.split('-')
            const dataTxt = `${day}/${month}/${year}`
            return dataTxt
        },

        retornaSigno(dt){
            let dia = dt.getDate()
            let mes = dt.getMonth() + 1
            let signo = null;

            switch (mes){
                case 1:
                    signo = dia <= 20 ? 'Capricórnio' : 'Aquário'
                    break;
                case 2:
                    signo = dia <= 18 ? 'Aquário' : 'Peixes'
                    break;
                case 3:
                    signo = dia <= 20 ? 'Peixes' : 'Áries'
                    break;
                case 4:
                    signo = dia <= 20 ? 'Áries' : 'Touro'
                    break;
                case 5:
                    signo = dia <= 20 ? 'Touro' : 'Gemeos'
                    break;
                case 6:
                    signo = dia <= 20 ? 'Gemeos' : 'Câncer'
                    break;
                case 7:
                    signo = dia <= 22 ? 'Câncer' : 'Leão'
                    break;
                case 8:
                    signo = dia <= 22 ? 'Leão' : 'Virgem'
                    break;
                case 9:
                    signo = dia <= 22 ? 'Virgem' : 'Libra'
                    break;
                case 10:
                    signo = dia <= 22 ? 'Libra' : 'Escorpião'
                    break;
                case 11:
                    signo = dia <= 21 ? 'Escorpião' : 'Sagitario'
                    break;
                case 12:
                    signo = dia <= 21 ? 'Sagitario' : 'Capricórnio'
                    break;

            }
            return signo
        },

        retornaDesafio(dt){
            let dia = dt.getDate().toString()
            let tDia = dia.length
            
            while(tDia > 1){
                dia = dia.split('')
                let d = 0
                dia.forEach(v => {
                    d += parseInt(v)
                })
                dia = d.toString()
                tDia = dia.length
            }
            

            let mes = (dt.getMonth() + 1).toString()
            let tMes = mes.length
            while(tMes > 1){
                mes = mes.split('')
                let m = 0
                mes.forEach(v => {
                    m += parseInt(v)
                })
                mes = m.toString()
                tMes = mes.length
            }

            let ano = dt.getFullYear().toString()
            let tAno = ano.length
            while(tAno > 1){
                ano = ano.split('')
                let a = 0
                ano.forEach(v => {
                    a += parseInt(v)
                })
                ano = a.toString()
                tAno = ano.length
            }

            let diff1 = Math.abs(parseInt(dia) - parseInt(mes))
            let diff2 = Math.abs(parseInt(mes) - parseInt(ano))
            return Math.abs(parseInt(diff1) - parseInt(diff2))
            
        },

        retornaMestre(dt){
            let ano = dt.getFullYear()
            let mestre = "Não há"
            let mestres = []
            mestres.push([new Date('01/01/' + ano), new Date('01/04/' + ano), 'Saint Germain'])
            mestres.push([new Date('01/06/' + ano), new Date('01/13/' + ano), 'El Morya'])
            mestres.push([new Date('01/14/' + ano), new Date('01/21/' + ano), 'Nada'])
            mestres.push([new Date('01/22/' + ano), new Date('01/29/' + ano), 'Veneziano'])
            mestres.push([new Date('01/30/' + ano), new Date('02/06/' + ano), 'Nada'])
            mestres.push([new Date('02/07/' + ano), new Date('02/14/' + ano), 'Principe Uriel'])
            mestres.push([new Date('02/15/' + ano), new Date('02/22/' + ano), 'Hilarion'])
            mestres.push([new Date('02/23/' + ano), new Date('03/02/' + ano), 'Seraphis Bay'])
            mestres.push([new Date('03/03/' + ano), new Date('03/10/' + ano), 'Lanto'])
            mestres.push([new Date('03/11/' + ano), new Date('03/18/' + ano), 'Saint Germain'])
            
            mestres.push([new Date('03/20/' + ano), new Date('03/27/' + ano), 'El Morya'])
            mestres.push([new Date('03/28/' + ano), new Date('04/04/' + ano), 'Nada'])
            mestres.push([new Date('04/05/' + ano), new Date('04/12/' + ano), 'Veneziano'])
            mestres.push([new Date('04/13/' + ano), new Date('04/20/' + ano), 'Nada'])
            mestres.push([new Date('04/21/' + ano), new Date('04/28/' + ano), 'Principe Uriel'])
            mestres.push([new Date('04/29/' + ano), new Date('05/06/' + ano), 'Hilarion'])
            mestres.push([new Date('05/07/' + ano), new Date('05/14/' + ano), 'Seraphis Bay'])
            mestres.push([new Date('05/15/' + ano), new Date('05/22/' + ano), 'Lanto'])
            mestres.push([new Date('05/23/' + ano), new Date('05/30/' + ano), 'Saint Germain'])
            
            mestres.push([new Date('06/01/' + ano), new Date('06/08/' + ano), 'El Morya'])
            mestres.push([new Date('06/09/' + ano), new Date('06/16/' + ano), 'Nada'])
            mestres.push([new Date('06/17/' + ano), new Date('06/24/' + ano), 'Veneziano'])
            mestres.push([new Date('06/25/' + ano), new Date('07/02/' + ano), 'Nada'])
            mestres.push([new Date('07/03/' + ano), new Date('07/10/' + ano), 'Principe Uriel'])
            mestres.push([new Date('07/11/' + ano), new Date('07/18/' + ano), 'Hilarion'])
            mestres.push([new Date('07/19/' + ano), new Date('07/26/' + ano), 'Seraphis Bay'])
            mestres.push([new Date('07/27/' + ano), new Date('08/03/' + ano), 'Lanto'])
            mestres.push([new Date('08/04/' + ano), new Date('08/11/' + ano), 'Saint Germain'])
            
            mestres.push([new Date('08/13/' + ano), new Date('08/20/' + ano), 'El Morya'])
            mestres.push([new Date('08/21/' + ano), new Date('08/28/' + ano), 'Nada'])
            mestres.push([new Date('08/29/' + ano), new Date('09/05/' + ano), 'Veneziano'])
            mestres.push([new Date('09/06/' + ano), new Date('09/13/' + ano), 'Nada'])
            mestres.push([new Date('09/14/' + ano), new Date('09/21/' + ano), 'Principe Uriel'])
            mestres.push([new Date('09/22/' + ano), new Date('09/29/' + ano), 'Hilarion'])
            mestres.push([new Date('09/30/' + ano), new Date('10/07/' + ano), 'Seraphis Bay'])
            mestres.push([new Date('10/08/' + ano), new Date('10/15/' + ano), 'Lanto'])
            mestres.push([new Date('10/16/' + ano), new Date('10/23/' + ano), 'Saint Germain'])
            
            mestres.push([new Date('10/25/' + ano), new Date('11/01/' + ano), 'El Morya'])
            mestres.push([new Date('11/02/' + ano), new Date('11/09/' + ano), 'Nada'])
            mestres.push([new Date('11/10/' + ano), new Date('11/17/' + ano), 'Veneziano'])
            mestres.push([new Date('11/18/' + ano), new Date('11/25/' + ano), 'Nada'])
            mestres.push([new Date('11/26/' + ano), new Date('12/03/' + ano), 'Principe Uriel'])
            mestres.push([new Date('12/04/' + ano), new Date('12/11/' + ano), 'Hilarion'])
            mestres.push([new Date('12/12/' + ano), new Date('12/19/' + ano), 'Seraphis Bay'])
            mestres.push([new Date('12/20/' + ano), new Date('12/27/' + ano), 'Lanto'])
            mestres.push([new Date('12/28/' + ano), new Date('12/31/' + ano), 'Saint Germain'])
            
            mestres.forEach((v)=>{
                if(dt >= v[0] && dt <= v[1]){
                    mestre = v[2]
                }
            })

            return mestre
            
        },

        verificaAcesso(acesso){
            let acessos = this.user.acessos
            let ac = acessos.some(v => {
				return v.id_item == acesso
            })
            
            return ac
        }
	}
}